module.exports = __webpack_public_path__ + "img/ctreeoflife_ua.af5904b1.webp";